import { Box, Stack } from '@mui/material'
import { Floor } from 'interface'
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import curPoint from './curPoint.png'
import floorPoint from './floorPoint.png'

interface Props {
  floor: Floor
  positions?: {
    x: number
    y: number
  }[]
  initPoint?: {
    x: number
    y: number
  }
}

export default function FloorImageMap({
  floor,
  positions = [],
  initPoint,
}: Props) {
  const [state, setState] = useState<{
    x: number
    y: number
  }>({
    x: 0,
    y: 0,
  })
  const parentRef = useRef<HTMLDivElement | null>(null)
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const [clientWidth, setClientWidth] = useState<number>(0)
  const curPointImg = useMemo(() => {
    const img = new Image()
    img.src = curPoint
    return img
  }, [])
  const pointImg = useMemo(() => {
    const img = new Image()
    img.src = floorPoint
    return img
  }, [])
  useEffect(() => {
    if (initPoint) setState(initPoint)
  }, [initPoint])

  useLayoutEffect(() => {
    const setSize = () => {
      if (parentRef.current) {
        setClientWidth(parentRef.current.clientWidth)
      }
    }
    setSize()
    window.addEventListener('resize', setSize)

    return () => {
      window.removeEventListener('resize', setSize)
    }
  }, [])
  useEffect(() => {
    if (floor && clientWidth) {
      if (canvasRef.current === null || !canvasRef.current) return
      const ctx = canvasRef.current.getContext('2d')
      const img = new Image()
      img.src = floor.floorImage
      img.onload = function () {
        const cvWidth = img.width > clientWidth ? clientWidth : img.width
        const cvHeight = (cvWidth * img.height) / img.width
        const size =
          cvWidth * 0.02 > 60 ? 60 : cvWidth * 0.02 < 20 ? 20 : cvWidth * 0.02
        if (parentRef && canvasRef.current) {
          canvasRef.current.width = cvWidth
          canvasRef.current.height = cvHeight
          if (ctx) {
            ctx.drawImage(
              img,
              0,
              0,
              cvWidth,
              (cvWidth * img.height) / img.width
            )
            positions.forEach(({ x, y }, i) => {
              const dx = (x / 100) * cvWidth
              const dy = (y / 100) * cvHeight
              ctx.drawImage(
                pointImg as any,
                dx - size / 2,
                dy - size / 2,
                size,
                size
              )
            })
            const { x, y } = state
            if (x && y && !initPoint) {
              const dx = (x / 100) * cvWidth
              const dy = ((y / 100) * (cvWidth * img.height)) / img.width
              ctx.drawImage(
                curPointImg as any,
                dx - size / 2,
                dy - size / 2,
                size,
                size
              )
            }
          }
        }
      }
    }
  }, [floor, positions, clientWidth, state, pointImg, curPointImg, initPoint])

  return (
    <Stack
      ref={parentRef}
      alignItems="center"
      justifyContent="center"
      width={'100%'}
    >
      <Box border={1} borderColor="#ccc" component="canvas" ref={canvasRef} />
    </Stack>
  )
}
